import { Component, OnInit, Input } from '@angular/core';

import { FormatService } from 'src/app/shared/services/format.service';
import { IndiceModeType } from 'src/app/shared/models/enums/indice-mode-type.enum';
import { OrganismDataItem } from 'src/app/shared/models/classes/citizen/organism-data-item';

@Component({
    selector: 'app-citizen-data-list',
    templateUrl: './citizen-data-list.component.html',
    styleUrls: ['./citizen-data-list.component.scss']
})
export class CitizenDataListComponent implements OnInit {
    @Input() dataList: OrganismDataItem[];

    constructor(
        private formatSrv: FormatService
    ) { }

    ngOnInit() {
    }

    formatValue(value: number, type: IndiceModeType): string | number {
        switch(type) {
            case IndiceModeType.percent:
                return this.formatSrv.formatPercent(value) + " %";
            case IndiceModeType.amount:
                return this.formatSrv.formatAmount(value) + " €";
            default:
                return this.formatSrv.formatAmount(value);
        }
    }
}
